import {REST_NEW_CURRENT_OFFERINGS} from "../constants/Rest.constants";

export const FetchOfferings = async ({
  search = "",
  filters = {},
  orderBy = "",
  descending = false,
  language = "en",
}) => {
  try {
    const baseUrl = `${REST_NEW_CURRENT_OFFERINGS}`;
    const params = new URLSearchParams();
    if (search) params.append("keyword", search);
    if (orderBy) params.append("orderBy", orderBy);
    if (descending) params.append("descending", true);
    params.append("language", language);

    Object.keys(filters).forEach((key) => {
      if (filters[key]) params.append(key, filters[key]);
    });
    const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    throw new Error(`Something went wrong: ${error}`);
  }
};
